<template>
    <b-card
    header-bg-variant="primary"
    header-class="py-2 px-3 text-white"
    body-class="p-3"
    footer-class="py-2 px-3"
    class="mx-0">
    <template #header>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 576 512"><path fill="#fff" d="M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1 0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7l255.4 224.5c8 7 12 15 11 24zM352 224a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm-96 96c-44.2 0-80 35.8-80 80 0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16 0-44.2-35.8-80-80-80h-64z"></path></svg>
        Mortgage
        <a href="javascript:void(0)" @click="$emit('remove-product-application', product_application.pcom_id)" class="position-absolute cursor-pointer" style="right: -14px; top: -7px;" v-if="is_editable">
            <svg xmlns="http://www.w3.org/2000/svg" class="mx-2" width="20" height="20" viewBox="0 0 512 512">
                <circle fill="#DF3030" cx="256" cy="256" r="256" />
                <g fill="#fff" transform="translate(148, 116) scale(0.55)">
                    <path fill="#fff" d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3l105.4 105.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256l105.3-105.4z"/>
                </g>
            </svg>
        </a>
    </template>

    <!--Card Body -->
    <div class="my-2">
        <p class="text-xs text-muted">Project</p>
        <p class="font-weight-600">{{ product_application.pcom_product_detail.pcp_project_name || 'N/A' }}</p>
    </div>
    <div class="my-2">
        <p class="text-xs text-muted">Unit No</p>
        <p class="font-weight-600">{{ product_application.pcom_product_detail.pcp_project_unit_no || 'N/A' }}</p>
    </div>
    <div class="my-2">
        <p class="text-xs text-muted">Loan Amt.</p>
        <p class="font-weight-600">RM{{ product_application.pcom_product_detail.pcp_loan_amount | moneyFormatter }}</p>
    </div>
    <div class="my-2">
        <p class="text-xs text-muted">Bank (Interest Rate)</p>
        <p class="font-weight-600">{{ product_application.pcom_bank_code }} ({{ product_application.pcom_product_detail.pcp_interest_rate }}%)</p>
    </div>
    <div class="my-2">
        <p class="text-xs text-muted">Monthly Installment</p>
        <p class="font-weight-600">RM{{ product_application.pcom_product_detail.pcp_monthly_installment }}</p>
    </div>
    <div class="my-2">
        <p class="text-xs text-muted">Tenure</p>
        <p class="font-weight-600">{{ product_application.pcom_product_detail.pcp_tenure }} Years</p>
    </div>
    <div class="my-2">
        <p class="text-xs text-muted">AF Amount (AF%)</p>
        <p class="font-weight-600">RM{{ product_application.pcom_product_detail.pcp_arragement_fee_amount | moneyFormatter }}</p>
    </div>
</b-card>
</template>
<script>

export default {
    props:['product_application', 'is_editable']
}
</script>